<mat-card class="content-card" style="padding-top: 15px; padding-bottom: 0; margin-top: 0; border-top-left-radius: 0; border-top-right-radius: 0;">

  <div>
    <div fxLayout="column" fxFlex="50">
      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">

        <mat-form-field class="country-filter-field">
          <mat-select [formControl]="countriesSelect" placeholder="Country" (selectionChange)="onCountryChange()" [(ngModel)]="customerOverviewFilters.countriesFilter" multiple>
            <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="identstatus-filter-field">
          <mat-select [formControl]="webIdStatusSelect" placeholder="Ident Status" (selectionChange)="onWebStatusChange()" [(ngModel)]="customerOverviewFilters.identStatusFilter" multiple>
            <mat-option *ngFor="let webId of webIdStatus | enumToArray" [value]="webId.index">{{webId.name | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="brand-filter-field" *ngIf="!currentUserIsPartner()">
          <mat-select [formControl]="companySelect" placeholder="Brand filters" (selectionChange)="onCompanyChange()" [(ngModel)]="customerOverviewFilters.companiesFilter" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <!-- #region star-end data, date filters, search -->



        <!-- #endregion star-end data, date filters, search -->


        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field style="width: 400px;" class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="customerOverviewFilters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </div>




    <div fxLayout="column" fxFlex="50">

    </div>

  </div>
</mat-card>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="mat-form-fullwidth">

    <div fxFlex="50">

        <div>
          <mat-card *ngIf="!showCustomerEdit" class="content-card">


              <mat-card-content>


                <div fxLayout="row">
                  <div fxFlex="50">
                    <button class="mr-1" mat-raised-button color="primary" [class.spinner]="loadingPrev" [disabled]="loadingPrevNext || !prevNextIds?.prevId" (click)="gotoPrevCustomer()">&lt;</button>
                    <button mat-raised-button color="primary" [class.spinner]="loadingNext" [disabled]="loadingPrevNext || !prevNextIds?.nextId" (click)="gotoNextCustomer()">&gt;</button>
                  </div>
                  <div fxFlex="50" class="text-center" style="text-align: right;">

                    <div>
                      <app-customer-badges *ngIf="customer" [customer]="customer"></app-customer-badges>
                    </div>

                  </div>
                </div>



                <div class="ml-1" *ngIf="customer">
                  <h2>
                    <ng-container *ngIf="yearsSinceAccountCreation >= 1 && yearsSinceAccountCreation <= 10">
                      <div style="display: inline-block; background-color: dimgrey; border-radius: 40px; height: 40px; width: 40px; text-align: center;">
                        <img [alt]="yearsSinceAccountCreation + ' years'" [src]="'assets/img/badges/loyalty/'+yearsSinceAccountCreation+'.png'" style="height: 30px; margin-top: 5px;" />
                      </div>

                    </ng-container> {{ customer.title }} {{ customer.firstName }} {{ customer.lastName | uppercase}}

                    </h2>




                </div>


                <!-- warnings -->
                <div *ngIf="customer" style="margin-left: 10px;">
                  <div *ngIf="customer.identStatus == identStatus.fail" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    <mat-icon style="color: white">beenhere</mat-icon> Ident failed!
                  </div>
                  <div *ngIf="customer.pepStatus == pepStatus.possibleMatch" style="border-radius: 4px; background-color: #ff9900; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    <mat-icon style="color: white">perm_identity</mat-icon> Possible PEP match!
                  </div>
                  <div *ngIf="customer.pepStatus == pepStatus.confirmedMatch" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    <mat-icon style="color: white">perm_identity</mat-icon> Confirmed PEP match!
                  </div>
                </div>

                <div *ngIf="customer" style="margin-left: 10px;">
                  <div *ngIf="customer.isVulnerable" style="border-radius: 4px; background-color: orange; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    🤕 This customer was marked vulnerable <ng-container *ngIf="customer.vulnerableDate">{{customer.vulnerableDate | date : 'yyyy-MM-dd'}}</ng-container>. Reason {{customer.vulnerableReason}}
                  </div>
                  <div *ngIf="customer.pepStatus == pepStatus.possibleMatch" style="border-radius: 4px; background-color: #ff9900; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    <mat-icon style="color: white">perm_identity</mat-icon> Possible PEP match!
                  </div>
                  <div *ngIf="customer.pepStatus == pepStatus.confirmedMatch" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                    <mat-icon style="color: white">perm_identity</mat-icon> Confirmed PEP match!
                  </div>
                </div>


                <ng-container *ngIf="customer?.isAutomaticLoadBlock">
                  <div style="background-color: #ff1c1c; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                    <mat-icon>info</mat-icon> Automatic Loads are blocked for this customer
                  </div>
                </ng-container>

                <ng-container *ngIf="customer?.isAllLoadBlock">
                  <div style="background-color: #ff1c1c; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                    <mat-icon>info</mat-icon> All Loads are blocked for this customer
                  </div>
                </ng-container>

                <ng-container *ngIf="currentUserIsAdmin() && customer?.isCollectionExempt">
                  <div style="background-color: #47a3ff; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                    <mat-icon>info</mat-icon> This customer is exempt from invoice collection
                  </div>
                </ng-container>

                <ng-container *ngIf="customer?.isAnonymized">
                  <div style="background-color: #ff9a47; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                    <mat-icon>info</mat-icon> This customer's data is anonymized
                  </div>
                </ng-container>


                <ng-container *ngIf="currentUserIsAdmin() && customer?.preventAutoConversionToPhysical">
                  <div style="background-color: #ff8e47; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                    <mat-icon>info</mat-icon> This customer's virtual cards will not be automatically converted to physical
                  </div>
                </ng-container>

                <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
                  <app-content-row [field]="field" [entity]="customer"></app-content-row>
                </div>

                <div class="list-item" fxLayout="row">
                  <label fxFlex="35" class="secondary">Ident Level</label>
                  <label [fxFlex]="32" *ngIf="customer">
                    <mat-select placeholder="Select new IDV level" [(value)]="newIdvLevelSelect" [disabled]="isLoadingCustomer || customer?.isAnonymized">
                      <mat-option [value]="identLevel.Unknown">0: Unknown</mat-option>
                      <mat-option [value]="identLevel.Sdd">1: SDD</mat-option>
                      <mat-option [value]="identLevel.Fdd">2: FDD</mat-option>
                      <mat-option [value]="identLevel.Edd">3: EDD</mat-option>
                    </mat-select>
                  </label>
                  <label [fxFlex]="33" *ngIf="customer" style="text-align: right;">
                    <button mat-raised-button color="blue" [disabled]="(!currentUserIsAdminOrCompliance()) || customer.isAnonymized || newIdvLevelSelect == null || newIdvLevelSelect == customer.identLevel || newIdvLevelSelect === identLevel.Unknown || _isSettingIdentLevel"  [class.spinner]="_isSettingIdentLevel" (click)="setCustomerIdLevel()"><mat-icon>account_box</mat-icon> Set Ident Level</button>
                  </label>
                </div>

                <div class="list-item" fxLayout="row">
                  <label fxFlex="35" class="secondary">PEP Status</label>
                  <label [fxFlex]="32" *ngIf="customer">
                    <mat-select placeholder="Select new PEP status" [(value)]="newPepStatusToSelect" [disabled]="isLoadingCustomer || customer?.isAnonymized">
                      <mat-option [value]="pepStatus.pending">0: Pending</mat-option>
                      <mat-option [value]="pepStatus.noMatch">1: No match</mat-option>
                      <mat-option [value]="pepStatus.possibleMatch">2: Possible match</mat-option>
                      <mat-option [value]="pepStatus.confirmedMatch">3: Confirmed match</mat-option>
                      <mat-option [value]="pepStatus.falsePositive">4: False positive</mat-option>
                    </mat-select>
                  </label>
                  <label [fxFlex]="33" *ngIf="customer" style="text-align: right;">
                    <button mat-raised-button color="blue" [disabled]="(!currentUserIsAdminOrCompliance()) || newPepStatusToSelect == null || newPepStatusToSelect == customer.pepStatus" (click)="setCustomerPepStatus(newPepStatusToSet)"><mat-icon>place</mat-icon> Set PEP status</button>
                  </label>
                </div>

                <div class="list-item" fxLayout="row">
                  <label fxFlex="35" class="secondary">Address Status</label>
                  <label [fxFlex]="32" *ngIf="customer">
                    <mat-select placeholder="Select new Address Status" [(value)]="newAddressStatusSelect" [disabled]="isLoadingCustomer || customer?.isAnonymized">
                      <mat-option [value]="addressStatus.Unconfirmed">0: Unconfirmed</mat-option>
                      <mat-option [value]="addressStatus.WaitingForDocuments">1: Waiting for documents</mat-option>
                      <mat-option [value]="addressStatus.PendingCheck">2: Pending check</mat-option>
                      <mat-option [value]="addressStatus.Confirmed">5: Confirmed</mat-option>
                    </mat-select>
                  </label>
                  <label [fxFlex]="33" *ngIf="customer" style="text-align: right;">
                    <button mat-raised-button color="blue" [disabled]="(!currentUserIsAdminOrCompliance()) || newAddressStatusSelect == null || newAddressStatusSelect == customer.addressStatus" (click)="setCustomerAddressStatus(newAddressStatusSelect)"><mat-icon>place</mat-icon> Set Address Status</button>
                  </label>
                </div>

                <div style="width: 100%; padding-bottom: 3rem; padding-top: 3rem">

                  <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">

                    <div fxFlex="50">
                      <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">Request documentation</div>
                      <div class="mb-1">
                        <button mat-raised-button class="mr-1" color="blue" [disabled]="!customer || customer.archived || customer.isAnonymized || isIdentLinkDisabled()" (click)="sendIdentLink(customer)">🔍 Request Ident</button>
                        <!--<button mat-raised-button class="mr-1" color="blue" [disabled]="isDocsDisabled(customer)" (click)="sendDocsLink(customer)"><mat-icon>insert_drive_file</mat-icon> Docs</button>-->
                      </div>
                      <div class="mb-1">
                        <button mat-raised-button class="mr-1" color="blue" [disabled]="isRequestSofDisabled(customer) || customer.isAnonymized" (click)="sendSofGenericLink(customer)">🧾 Request SOF Generic</button>
                      </div>
                      <div class="mb-1">
                        <button mat-raised-button class="mr-1" color="blue" [disabled]="isRequestPoaDisabled(customer) || customer.isAnonymized" (click)="sendPoaLink(customer)">🏠 Request POA</button>
                      </div>

                      <div class="mt-1" *ngIf="customer">
                        <button (click)="markAsVulnerable(customer)" [class.spinner]="isMarkingAsVulnerable" [disabled]="isMarkingAsVulnerable || customer.isVulnerable" class="mr-1"
                                color="grey" mat-raised-button>
                          🤕 Mark customer as vulnerable
                        </button>
                      </div>

                    </div>

                    <div fxFlex="50">
                      <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">Change data</div>
                      <div class="mb-1">

                        <button mat-raised-button class="mr-1" color="blue" [disabled]="isChangeAddressDisabled(customer) || customer.isAnonymized" (click)="sendChangeAddressLink(customer)">🏠 Change Address</button>
                        <a mat-raised-button class="mr-1" color="primary" (click)="changePhone()" *ngIf="(currentUserIsPartner() || currentUserIsAdmin()) && customer != null">📱 Change phone </a>
                        <a mat-raised-button class="mr-1" color="primary" (click)="changeEmail()" *ngIf="currentUserIsPartner() && customer">📧 Change e-mail</a>
                        <a mat-raised-button color="primary" (click)="onShowCustomerEdit(true)"  *ngIf="editEnabled()">📝 Edit</a>
                      </div>
                      <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">Sync to Card Processor</div>
                      <div class="mb-1">
                        <a mat-raised-button class="mr-1" color="purple" (click)="onSyncPersonalDataToGps()" *ngIf="!currentUserIsPartner() && customer != null">🔄 Sync Personal Data</a>
                        <a mat-raised-button class="mr-1" color="purple" (click)="onSyncAddressToGps()" *ngIf="!currentUserIsPartner() && customer != null">🔄 Sync Address</a>
                      </div>
                      <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">Sync MicroPayment</div>
                      <div class="mb-1">
                        <a mat-raised-button class="mr-1" color="turquoise" (click)="syncMicroPaymentSessions(customer.id)" *ngIf="!currentUserIsPartner() && customer != null">🔄 Sync MicroPayment Transactions</a>
                      </div>
                    </div>
                  </div>

                  <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">

                    <div fxFlex="50">
                      <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">Personal Data</div>
                      <div class="mb-1">
                        <button *ngIf="customer && !customer.isAnonymized" [class.spinner]="isAnonymizing" mat-raised-button class="mr-1" color="blue" [disabled]="isAnonymizing || !customer || customer.isAnonymized" (click)="anonymizeCustomer(customer)">🔐 Anonymize personal data</button>
                        <button *ngIf="customer && customer.isAnonymized" [class.spinner]="isAnonymizing" mat-raised-button class="mr-1" color="blue" [disabled]="isAnonymizing || !customer || !customer.isAnonymized" (click)="restoreAnonymizedCustomer(customer)">🔐 Restore anonymized personal data</button>
                      </div>

                    </div>

                    <div fxFlex="50">

                    </div>
                  </div>

                </div>

                <div *ngIf="this.customer && !currentUserIsPartner()" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">

                  <div fxFlex="50">
                    <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">👁‍🗨 Submit for Risk Assessment</div>
                    <div class="mb-1">
                      <ng-container class="content-card">
                        <div *ngIf="activeRiskAssessmentInquiry == null">
                          <form *ngIf="this.customer && this.newRiskAssessmentForm" (ngSubmit)="onRiskAssesmentFormSubmit()" [formGroup]="newRiskAssessmentForm" class="">

                            <table width="100%">
                              <tr>
                                <td>
                                  <mat-form-field>
                                    <input matInput placeholder="Inquiry Comment" formControlName="inquiryComment">
                                  </mat-form-field>
                                </td>
                                <td style="width:0%; cursor: pointer;">
                                  <button *ngIf="activeRiskAssessmentInquiry == null" mat-icon-button type="submit" [disabled]="!newRiskAssessmentForm.valid || newRiskAssessmentForm.pristine || disableRiskAssBtn" (click)="onRiskAssesmentFormSubmit()"><mat-icon>send</mat-icon></button>
                                </td>
                              </tr>
                            </table>


                          </form>
                        </div>
                        <div *ngIf="activeRiskAssessmentInquiry != null" style="background-color: orange; padding: 4px; border-radius: 4px; color: black; vertical-align: center;">
                          <mat-icon>access_time</mat-icon> pending since {{ activeRiskAssessmentInquiry.inquiryDate | date: "dd.MM.yyyy HH:mm" }}
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div fxFlex="50">


                  </div>

                </div>

                <!--<button mat-raised-button style="margin-right: 5rem;" color="primary" *ngIf="customer && currentUserIsAdminOrCompliance()" [disabled]="!currentUserIsAdminOrCompliance()" (click)="createInternalDocsLink(customer)">Upload Docs</button>-->

                <!--<a mat-raised-button color="primary" (click)="returnBack()">Back</a>-->
                <!--<a mat-raised-button color="primary" routerLink="edit" *ngIf="editEnabled()">Edit</a>-->


              </mat-card-content>



          </mat-card>

          <form *ngIf="editEnabled() && showCustomerEdit && customerForm" [formGroup]="customerForm" (ngSubmit)="onCustomerEditFormSubmit()" class="content-card">
            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>Customer Edit</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <ng-container *ngIf="currentUserIsAdmin()">
                  <div style="background-color: #47a3ff; padding: 10px; margin-bottom: 10px;">
                    <mat-slide-toggle formControlName="isCollectionExempt">
                      Exempt this customer from invoice collection
                    </mat-slide-toggle>
                  </div>
                </ng-container>

                <ng-container *ngIf="currentUserIsAdmin()">
                  <div style="background-color: #ff8e47; padding: 10px; margin-bottom: 10px;">
                    <mat-slide-toggle formControlName="preventAutoConversionToPhysical">
                      Prevent automatic conversion of this customer's virtual cards to physical
                    </mat-slide-toggle>
                  </div>
                </ng-container>

                <ng-container *ngIf="currentUserIsAdmin()">
                  <div style="background-color: #ffe647; padding: 10px; margin-bottom: 10px;">
                    <mat-slide-toggle formControlName="isAutomaticLoadBlock">
                      Block automatic loads for this customer
                    </mat-slide-toggle>
                  </div>
                </ng-container>

                <ng-container *ngIf="currentUserIsAdmin()">
                  <div style="background-color: #ff8747; padding: 10px; margin-bottom: 10px;">
                    <mat-slide-toggle formControlName="isAllLoadBlock">
                      Block ALL loads for this customer
                    </mat-slide-toggle>
                  </div>
                </ng-container>

                <mat-form-field>
                  <input matInput placeholder="Title" formControlName="title" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Sex" formControlName="sex" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="First name" formControlName="firstName" maxlength="50" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Last name" formControlName="lastName" maxlength="50" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Address" formControlName="address" maxlength="50" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="City" formControlName="city" maxlength="50" required>
                </mat-form-field>
                <mat-form-field>
                  <mat-select placeholder="Country" formControlName="countryIsoCode" required>
                    <mat-option *ngFor="let country of countiries" [value]="country.isoCode">{{country.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Zip code" formControlName="zipCode" maxlength="50" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Email" formControlName="email" maxlength="60" required email>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Nationality" formControlName="nationality" required>
                </mat-form-field>
                <mat-form-field>
                  <mat-select placeholder="Subscribed to news" formControlName="subscribeToNews" required>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Mobile" formControlName="phone" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15">
                </mat-form-field>
                <app-date-edit formControlName="dob"  placeholder="Date of birth"></app-date-edit>
                <mat-form-field>
                  <mat-select placeholder="Order language" formControlName="orderLanguage" required>
                    <mat-option [value]="0">german</mat-option>
                    <mat-option [value]="1">english</mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button color="accent" type="button" [disabled]="isUpdatingCustomer" (click)="onShowCustomerEdit(false)" >Cancel</button>
                <button mat-raised-button color="primary" type="submit" [disabled]="!customerForm.valid || customerForm.pristine || isUpdatingCustomer" [class.spinner]="isUpdatingCustomer">Save</button>
              </mat-card-actions>
            </mat-card>
          </form>

        </div>

      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent() && addressUploadFiles != null && addressUploadFiles.length > 0">
        <mat-card-header>
          <mat-card-title>
            <h5>🏠 Address documents</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left; width: 120px;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
              <th style="text-align: left"><label>File</label></th>
              <th style="text-align: left"><label>Status</label></th>
            </tr>
            <ng-container  *ngFor="let f of addressUploadFiles">
              <tr [class.noborderbottom]="f.comment">
                <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
                <td><label>{{getPoaTypeName(f.typName)}}</label></td>
                <td><label>{{f.docType}}</label></td>
                <td>
                  <label *ngIf="currentUserIsAdminOrCompliance()">
                    <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                  </label>
                  <label *ngIf="!currentUserIsAdminOrCompliance()">
                    {{ f.originalFileName }}
                  </label>
                </td>
                <td>
                  <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                  <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                  <label *ngIf="f.isSuccess == null">-</label>
                </td>
              </tr>
              <ng-container *ngIf="f.comment">
                <tr>
                  <td colspan="5" style="border-top: none; font-size: .8em; ">
                    <div>
                      📑 {{f.comment}}
                    </div>
                    <div style="font-weight: bold; font-size: .9em; padding-left: 5px;font-family: monospace">
                      {{f.decisionUserInitials}} ({{f.decisionUserEmail}})
                    </div>
                  </td>

                </tr>
              </ng-container>

            </ng-container>
          </table>



          <!--<table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left; width: 120px;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
              <th style="text-align: left"><label>File</label></th>
              <th style="text-align: left"><label>Status</label></th>
            </tr>
            <tr *ngFor="let f of addressUploadFiles">
              <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{f.typName}}</label></td>
              <td><label>{{f.docType}}</label></td>
              <td>
                <label *ngIf="currentUserIsAdminOrCompliance()">
                  <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                </label>
                <label *ngIf="!currentUserIsAdminOrCompliance()">
                  {{ f.originalFileName }}
                </label>
              </td>
              <td>
                <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                <label *ngIf="f.isSuccess == null">-</label>
              </td>
            </tr>
          </table>-->
          <!--
          <hr *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived"  />
          <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
            {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br /><br />
            <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsLink(customer)">resend Doc Link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount" (click)="resendDocsPaymentLink(customer)">resend payment link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsInvoice(customer)">send Invoice</button>
          </div>
          -->

        </mat-card-content>
      </mat-card>


      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>💳 Cards</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <mat-progress-bar *ngIf="isLoadingCards" mode="indeterminate"></mat-progress-bar>

          <mat-accordion class="" *ngIf="!isLoadingCards">
            <mat-expansion-panel disabled=true>
              <mat-expansion-panel-header>
                <mat-panel-title style="width: 35px;">

                </mat-panel-title>
                <mat-panel-title>
                  Card
                </mat-panel-title>
                <mat-panel-title>
                  Token
                </mat-panel-title>
                <mat-panel-title>
                  Last 4
                </mat-panel-title>
                <mat-panel-title>
                  Exp.
                </mat-panel-title>
                <mat-panel-title>
                  Balance * / Cashback
                </mat-panel-title>

                <mat-panel-title>
                  Status
                </mat-panel-title>
                <!--<mat-panel-title>
                  Last Payment Reminder
                </mat-panel-title>-->
              </mat-expansion-panel-header>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let cardContainer of cardContainers">
              <mat-expansion-panel-header>
                <mat-panel-title style="width: 35px;">
                  <img *ngIf="productLogoUrl[cardContainer.card.productId]" [src]="productLogoUrl[cardContainer.card.productId]" style="width: 30px; height: 19px;" alt="Product Logo" />
                </mat-panel-title>
                <mat-panel-title>
                  <span *ngIf="cardContainer.gpsCardStatusCached" [matTooltip]="gpsCardStatusHelper.getText(cardContainer.gpsCardStatusCached)" style="margin-right: 5px;">
                    {{ gpsCardStatusHelper.getIcon(cardContainer.gpsCardStatusCached) }}
                  </span>
                  {{cardContainer.card.product.internalName}}
                  <span [style.background-color]="'#'+cardContainer.card.displayColor" style="margin-left: 5px; border-radius: 3px; padding: 2px; text-align: center; font-size: .8em; width: 15px; height: 15px; ">
                    <span *ngIf="cardContainer.card.cardType == cardType.Virtual || cardContainer.card.cardType == cardType.InitiallyVirtual">V</span>
                    <span *ngIf="cardContainer.card.cardType == cardType.Physical">P</span>
                    <span *ngIf="cardContainer.card.cardType == cardType.Pseudo">F</span>
                  </span>
                </mat-panel-title>
                <mat-panel-title>
                  {{cardContainer.card.token}}
                  <span *ngIf="cardContainer.card.status !== 6 && cardContainer.card.usageStatus == cardUsageStatus.dormant" [matTooltip]="'Dormant card'">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">💤</div>
                  </span>

                  <span *ngIf="cardContainer.pendingExtension" [matTooltip]="'Extension pending'">
                    <div style="height: 20px; width: 20px; background-color: #2dc5e3; margin-right: 3px; text-align: center">E</div>
                  </span>
                  <span *ngIf="cardContainer.pendingReorder" [matTooltip]="'Reorder pending'">
                    <div style="height: 20px; width: 20px; background-color: #e5d089; border-radius: 3px; margin-right: 3px; text-align: center">R</div>
                  </span>

                  <span *ngIf="cardContainer.card.primaryCardId" [matTooltip]="'Linked to ' + cardContainer.card.primaryToken">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">⛓</div>
                  </span>

                </mat-panel-title>
                <mat-panel-title>
                  <span *ngIf="cardContainer.card.maskedPAN">
                    *{{cardContainer.card.maskedPAN.substring(12) }}
                  </span>
                </mat-panel-title>
                <mat-panel-title>
                  {{cardContainer.card.expireDate | date: 'MM/yy'}}
                </mat-panel-title>
                <mat-panel-title>
                  <span *ngIf="cardContainer.lastKnownAvailableBalance">
                    {{cardContainer.lastKnownAvailableBalance.toFixed(2) }} /
                    <span *ngIf="cardContainer.cashbackSummary">
                      {{cardContainer.cashbackSummary.payableAmount || "-" }}
                  </span>
                  </span>
                </mat-panel-title>


                <mat-panel-title class=" {{cardContainer.card.status == 6 ? 'warning-row' : ''}}">
                  <span *ngIf="cardContainer.card.status == 6">⛔️ </span>
                  {{cardContainer.card.statusName}}<div style="display: inline-block; margin-left: 4px; padding: 3px; background-color: dodgerblue; border-radius: 3px; color: black; font-size: .8em;" *ngIf="cardContainer.card.reorderReason">R</div>
                </mat-panel-title>
                <!--<mat-panel-title>
                  {{cardContainer.card.order.paymentEmailReminders && cardContainer.card.order.paymentEmailReminders[cardContainer.card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
                </mat-panel-title>-->
              </mat-expansion-panel-header>

              <div *ngIf="cardContainer.card.reorderReason" style="margin: 5px; padding: 5px; border-radius: 5px; background-color: dodgerblue">
                <b>This card has been re-ordered</b><br />
                <hr style="border-top: 1px solid black; border-bottom: none;" />
                <span *ngIf="cardContainer.card.reorderReason === cardReorderReason.LostOrStolen">Lost or stolen</span>
                <span *ngIf="cardContainer.card.reorderReason === cardReorderReason.CardNotArrived">Card not arrived</span>
                <span *ngIf="cardContainer.card.reorderReason === cardReorderReason.Expired">Expired</span>
                , Comment: <i>{{ cardContainer.card.reorderComment }}</i>
              </div>

              <div *ngIf="!currentUserIsAdminOrCompliance() && !currentUserIsSupportManager() && (cardContainer.gpsCardStatusCached != '00' && cardContainer.gpsCardStatusCached != '62' && cardContainer.gpsCardStatusCached != '41' && cardContainer.gpsCardStatusCached != '43' ) " style="padding: 2px; background-color: yellow; font-size: .8em;">
                You may not have permissions to re-order this card since it is in status {{ cardContainer.gpsCardStatusCached || "(unknown)" }}
              </div>

              <div *ngIf="cardContainer.extensions != null && cardContainer.extensions.length > 0" style="background-color: #2dc5e3; font-size: .8em; padding: 5px; margin-top: 5px">
                <b>Card Extensions</b>
                <div *ngFor="let extension of cardContainer.extensions">
                  <div>
                    on {{ extension.extensionDate | date:"yyyy-MM-dd" }}:
                    {{ extension.oldExpiryDate | date:"MM/yy" }} -> <span *ngIf="extension.newExpiryDate">{{ extension.newExpiryDate | date:"MM/yy" }}</span>

                    <span *ngIf="extension.status === 1" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Pending</span>
                    <span *ngIf="extension.status === 2" style="background-color: orange; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Waiting for execution</span>
                    <span *ngIf="extension.status === 3" style="background-color: dodgerblue; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Executed</span>
                    <span *ngIf="extension.status === 4" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Activated</span>
                    <span *ngIf="extension.status === 9" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Failed</span>


                  </div>
                </div>
              </div>

              <div *ngIf="cardContainer.pendingExtension" style="background-color: #2dc5e3; font-size: .8em; padding: 5px; margin-top: 5px;">
                An extension of this card is pending, waiting for activation...
              </div>

              <div *ngIf="cardContainer.pendingReorder" style="background-color: #e5d089; font-size: .8em; padding: 5px; margin-top: 5px;">
                A re-order of this card is pending since {{cardContainer.pendingReorder.createDate|date:'dd.MM.yyyy' }}, Reason:

                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.None">None</span>
                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.NoIdent">Not identified</span>
                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.OverdueInvoice">Overdue invoice</span>
                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.Other">Other</span>
                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.MultipleReorders">Multiple Re-Orders</span>
                <span *ngIf="cardContainer.pendingReorder.delayReason === reorderDelayReason.AddressUnconfirmed">Address unconfirmed</span>
                {{ cardContainer.pendingReorder.delayComment }}


              </div>

              <div *ngIf="cardContainer.card.isQueuedForConversion" style="background-color: #c6e589; font-size: .8em; padding: 5px; margin-top: 5px;">
                This card is queued to be converted to physical
              </div>



              <div style="padding: 3px;">
                <span style="margin: 5px; padding: 3px; background-color: #bbe4fd; border-radius: 5px;" *ngIf="cardContainer.card.primaryCardId">Linked to {{ cardContainer.card.primaryToken }}</span>
                <span style="margin: 5px; padding: 3px; background-color: #bbe4fd; border-radius: 5px;" *ngIf="cardContainer.card.isVirtualOnly">This card is virtual only</span>
              </div>

              <div class="list-item" fxLayout="row" *ngFor="let field of cardFields">
                <app-content-row [field]="field" [entity]="cardContainer"></app-content-row>

                <div *ngIf="field.cell(cardContainer).startsWith('&lt;a i') && !cardContainer.card.order.invoice">
                  <i>This card's order has no invoice</i>
                </div>

                <mat-expansion-panel fxFlex="100" class="" *ngIf="field.cell(cardContainer).startsWith('&lt;a i') && cardContainer.card.order.invoice">
                  <mat-expansion-panel-header>
                    Invoice {{ cardContainer.card.order.invoice.code }}
                  </mat-expansion-panel-header>
                  <div style="background: #e3f3ff;" *ngIf="!getCardItemById(cardContainer.card.id).editVisible">
                    <div class="list-item" fxLayout="row" *ngFor="let field of invoiceFields;">
                      <div fxFlex="35" class="secondary">{{ field.header }}</div>
                      <div fxFlex="65" >{{ field.cell(cardContainer.card.order.invoice) }}</div>
                    </div>
                    <div class="text-right mt-2" style="padding-right: 5px; padding-bottom: 5px;">
                      <button mat-raised-button color="primary" type="button" [disabled]="!currentUserIsAdmin()" (click)="onShowCardInvoiceEdit(cardContainer.card, true)">Edit</button>
                    </div>
                  </div>

                  <form *ngIf="cardContainer.card && cardContainer.card.order && cardContainer.card.order.invoice && getCardItemById(cardContainer.card.id).editVisible" [formGroup]="cardContainer.editForm" (ngSubmit)="onCardInvoiceEditSubmit(cardContainer.card)" class="content-card cardEdit">
                    <mat-card class="form-card">
                      <mat-card-content>
                        <mat-form-field >
                          <input matInput placeholder="Bill amount" formControlName="billAmount" readonly="true">
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Paid amount" formControlName="paidAmount" required  type="number">
                        </mat-form-field>
                      </mat-card-content>
                      <mat-card-actions align="end">
                        <button mat-raised-button color="accent" type="button" (click)="onShowCardInvoiceEdit(cardContainer.card, false)">Cancel</button>
                        <button mat-raised-button color="primary" type="submit" [disabled]="!cardContainer.editForm.valid || cardContainer.editForm.pristine">Save</button>
                      </mat-card-actions>
                    </mat-card>
                  </form>

                  <app-object-comments-view class="mt-2" caption="{{ cardContainer.card.order.invoice.code }} comments" *ngIf="cardContainer.card.order.invoice" [comments]="cardContainer.invoiceComments" [objectId]="cardContainer.card.order.invoice?.id" [target]="commentsInvoiceTarget"></app-object-comments-view>





                </mat-expansion-panel>

              </div>

              <ng-container *ngFor="let cashbackGroupMembership of cardContainer.card.cashbackGroupMemberships">

                <div class="list-item" fxLayout="row">
                  <label fxFlex="35" class="secondary">Cashback Group</label>
                  <label fxFlex="55">
                    <a [routerLink]="'../../administration/cashback-groups/' + cashbackGroupMembership.cashbackGroupId">
                      {{ cashbackGroupMembership.cashbackGroup.code }}
                    </a>
                  </label>
                  <label fxFlex="10">
                    <button mat-icon-button (click)="removeCardFromCashbackGroup(cardContainer.card, cashbackGroupMembership.cashbackGroup)" type="button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </label>
                </div>
              </ng-container>


              <mat-card-actions align="end" >
                <div *ngIf="showCardActions()">

                  <a mat-raised-button color="blue" (click)="displayAddCardToCashbackGroupDialog(cardContainer.card)">Cashback Groups</a>

                  <a *ngIf="cardContainer.card.status != 6" mat-raised-button color="accent" [disabled]="CloseCardDisabled(cardContainer.card)" (click)="closeCard(cardContainer.card.id)">Close Card</a>

                  <a *ngIf="cardContainer.card.status == 6" mat-raised-button color="orange" (click)="unCloseCard(cardContainer.card.id)">Un-Close Card</a>

                </div>

                <div>
                  <a mat-raised-button color="primary" [class.spinner]="isReorderingCard" [disabled]="isReorderingCard || isExtendingCard || cardContainer.card.status == 6 || cardContainer.pendingReorder != null" *ngIf="currentUserIsPartner() || showCardActions()" (click)="reorderCard(cardContainer.card.id)">Re-Order</a>

                  <a mat-raised-button color="turquoise" [class.spinner]="isExtendingCard"  [disabled]="isReorderingCard || isExtendingCard || cardContainer.card.status == 6 || cardContainer.pendingExtension != null || isExtendingCard" *ngIf="currentUserIsPartner() || showCardActions()" (click)="extendCard(cardContainer.card.token)">Extend Card</a>
                  <a mat-raised-button color="warn" style="margin-left: 20px;" *appHasRoles="['admin', 'manager', 'agent', 'compliance', 'partner']" (click)="cancelCard(cardContainer.card)" [disabled]="!CloseCardDisabled(cardContainer.card) || cardContainer.card.status == 6">Cancel card</a>

                  <a mat-raised-button color="turquoise" [disabled]="isReorderingCard || isExtendingCard || cardContainer.card.status == 6" [class.spinner]="isIssuingPseudoCard" *ngIf="cardContainer.card.cardType === cardType.Pseudo" (click)="issuePseudoCard(cardContainer.card.token)">Issue Card</a>
                  <a mat-raised-button color="turquoise" [disabled]="isReorderingCard || isExtendingCard || cardContainer.card.status == 6 || cardContainer.card.isQueuedForConversion || isQueueingCardForConversion" [class.spinner]="isQueueingCardForConversion" *ngIf="(cardContainer.card.cardType === cardType.Virtual || cardContainer.card.cardType === cardType.InitiallyVirtual)" (click)="queueCardForConversion(cardContainer.card.token)">Convert to physical</a>

                </div>
              </mat-card-actions>




            </mat-expansion-panel>
          </mat-accordion>


          <div style="margin: 15px; font-size: .8em;">* taken from cache - might be inaccurate</div>

        </mat-card-content>
        <mat-card-actions align="end">
          <div style="padding-right: 10px;">
            <button [class.spinner]="isOrderingNewCard" [disabled]="isOrderingNewCard" *ngIf="currentUserIsAdmin()" mat-raised-button color="blue" type="button" (click)="orderNewCard()"><mat-icon>add_shopping_cart</mat-icon> Add a new card</button>
          </div>
        </mat-card-actions>
      </mat-card>


      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
        <mat-card-header>
          <mat-card-title>
            <h5>📑 IBAN</h5>
          </mat-card-title>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">

          </div>

        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoadingIbans">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
            <label fxFlex="55" class="secondary">IBAN</label>
            <label fxFlex="25" class="secondary">BIC</label>
            <label fxFlex="10" class="secondary">Currency</label>
            <label fxFlex="10" class="secondary">Status</label>
            <label fxFlex="10" class="secondary">Created</label>
          </div>
          <div class="scroll mh-200">
            <ng-container  *ngFor="let ic of ibans">
              <div class="list-item" fxLayout="row" fxLayoutGap="10px">
                <label class="" fxFlex="55" >{{ prettyPrintIban(ic.iban) }}</label>
                <label class="" fxFlex="25" >{{ ic.bic }}</label>
                <label class="" fxFlex="10" >{{ ic.currency }}</label>
                <label class="" fxFlex="10" >{{ getIbanStatusString1(ic.statusId) }}</label>
                <label class="" fxFlex="10" >{{ ic.createDate | date: "dd.MM.yyyy HH:mm" }}</label>

              </div>


            </ng-container>
          </div>



        </mat-card-content>
      </mat-card>



      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>🪪 Ident Document</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <ng-container *ngIf="isLoadingCustomer">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
            <label fxFlex="20" class="secondary">Document</label>
            <label fxFlex="10" class="secondary">Expiry</label>
            <label fxFlex="35" class="secondary">Name</label>
            <label fxFlex="15" class="secondary">DOB</label>
          </div>

          <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngIf="customer">
            <label class="" fxFlex="20" >
              <div>
                {{ getIdentDocumentType(customer.identDocumentType) }}
              </div>
              <div>
                <span *ngIf="customer.identDocumentCountry">
                  <flag-icon country="{{ customer.identDocumentCountry.toLowerCase() }}"></flag-icon>
                </span> {{ customer.identDocumentNumber }}
              </div>
            </label>
            <label class="" fxFlex="10" >
              <ng-container *ngIf="customer.identValidUntilDate else noValidUntil">{{ customer.identValidUntilDate | date: "dd.MM.yyyy" }}</ng-container>
              <ng-template #noValidUntil><i>unknown</i></ng-template>
            </label>
            <label class="" fxFlex="35" >
              {{ customer.identDocumentFirstName }} {{ customer.identDocumentLastName }}
            </label>
            <label class="" fxFlex="15" >
              {{ customer.identDocumentDob | date: "dd.MM.yyyy" }}
            </label>

          </div>
        </mat-card-content>
        <mat-card-actions align="end">
          <div style="padding-right: 10px;">
          <button *ngIf="!currentUserIsIssuerExternal()" mat-raised-button color="blue" type="button" (click)="editCustomerIdentDocument()"><mat-icon>edit</mat-icon> Edit</button>
          </div>
        </mat-card-actions>
      </mat-card>


      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
        <mat-card-header>
          <mat-card-title>
            <h5>🛂 Ident Log</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <ng-container *ngIf="isLoadingIdentLog">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
            <label fxFlex="20" class="secondary">Date</label>
            <label fxFlex="15" class="secondary">Status</label>
            <label fxFlex="5" class="secondary"></label>
            <label fxFlex="15" class="secondary">Document</label>
            <label fxFlex="10" class="secondary">Doc Expiry</label>
          </div>
          <div class="scroll mh-300">
            <ng-container  *ngFor="let ic of idents">
            <div class="list-item" fxLayout="row" fxLayoutGap="10px">
              <label class="" fxFlex="20" >{{ ic.ident.creationDate | date: "dd.MM.yyyy HH:mm" }}</label>
              <label class="" fxFlex="15" >{{ getIdentStatusString1(ic.ident.status) }}</label>
              <label class="" fxFlex="5" >
                <span *ngIf="ic.ident.documentCountry">
                  <flag-icon country="{{ ic.ident.documentCountry.toLowerCase() }}"></flag-icon>
                </span>
              </label>
              <label class="" fxFlex="15" >
                <div>{{ ic.ident.documentType }}</div>
                <div style="margin-top: 5px;">Nr.: {{ ic.ident.documentNumber }}</div>
              </label>
              <label class="" fxFlex="10" >
                <ng-container *ngIf="ic.ident.documentValidUntil else noValidUntil">{{ ic.ident.documentValidUntil | date: "dd.MM.yyyy" }}</ng-container>
                <ng-template #noValidUntil><i>unknown</i></ng-template>
              </label>


              <button style="cursor: pointer; background-color: #dfe2e6; border: 1px solid #c2d5f1; border-radius: 3px; font-size: .9em;" *ngIf="!ic.files" (click)="getIdentFiles(ic.ident.id)">
                <mat-icon style="font-size: 1.3em; margin: 0">folder</mat-icon>
                FILES
              </button>
              <button style="cursor: pointer; background-color: #c2d5f1; border: 1px solid #a6bad6; border-radius: 3px; font-size: .9em;" *ngIf="ic.files" (click)="ic.files = null">
                <mat-icon style="font-size: 1.3em;">folder_open</mat-icon>
                FILES
              </button>
            </div>
            <mat-progress-bar *ngIf="isLoadingIdentFiles" mode="indeterminate"></mat-progress-bar>
            <ng-container *ngIf="ic.files && !isLoadingIdentFiles">
              <div class="list-item" fxLayout="row" fxLayoutGap="10px"  *ngFor="let f of ic.files" style="margin: 10px;" (click)="previewIdentFile(f.uploadId)">
                  <div fxFlex="40" style="text-decoration: underline; color: blue; cursor: pointer">{{ f.fileType }}</div>
                  <div fxFlex="40" style="text-decoration: underline; color: blue; cursor: pointer">{{ f.upload.fileName }}</div>
                  <div fxFlex="20" style="text-decoration: underline; color: blue; cursor: pointer">{{ f.mediaType == 1 ? 'Video' : 'Image' }}</div>
                </div>
            </ng-container>

          </ng-container>
          </div>


          <div *ngIf="previewFileOpen">
            <iframe class="resp-iframe" height="1000" width="100%" frameBorder="1" *ngIf="this.previewType === 1" [src]="previewUrlSafe" ></iframe>
            <img [src]="previewUrlSafe" style="width: 100%; height:auto;" *ngIf="this.previewType === 2" />
          </div>


        </mat-card-content>
      </mat-card>





      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
        <mat-card-header>
          <mat-card-title>
            <h5>📑 IDV / SOF</h5>
          </mat-card-title>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <a style="font-size: .9em;" [routerLink]="'../../idv-customers-overview/' + customer?.id">Approve / Decline</a>
          </div>

        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoadingIdvSof">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>
          <div *ngIf="currentUserIsAdminOrComplianceOrManager() && lastDocLinkToken != null" style="margin-bottom: 15px;">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h5>Upload Docs</h5>
                </mat-panel-title>
                <mat-panel-description>

                </mat-panel-description>
              </mat-expansion-panel-header>


              <ngx-dropzone (change)="onSelect($event)" [accept]="'image/*, application/pdf'" [multiple]="true"
                            [maxFileSize]="10485760" [disabled]="!currentUserIsAdminOrComplianceOrManager()">
                <ngx-dropzone-label *ngIf="true">UPLOAD DOCS</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
              <div [hidden]="!isUploading">
                <div class="spinner-2">
                  <mat-spinner align="center"></mat-spinner>
                </div>
              </div>
              <button style="margin-top: 5px; margin-bottom: 15px;" *ngIf="true"
                      [disabled]="files == null || files.length <= 0 || isUploading" mat-raised-button color="primary" type="button"
                      (click)="upload()">Upload
              </button>
            </mat-expansion-panel>
          </div>

              <!-- SOF GENERIC UPLOAD -->


              <div *ngIf="currentUserIsAdminOrComplianceOrManager()" style="margin-bottom: 15px;">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title style="width: 100%">
                      <h5>Upload SOF <ng-container *ngIf="!lastSofGenericLinkToken"> <span style="color: dodgerblue">(Direct upload, no active link)</span></ng-container></h5>
                    </mat-panel-title>
                    <mat-panel-description>

                    </mat-panel-description>
                  </mat-expansion-panel-header>


                  <ngx-dropzone (change)="onSelectSof($event)" [accept]="'image/*, application/pdf'" [multiple]="true"
                                [maxFileSize]="10485760" [disabled]="!currentUserIsAdminOrComplianceOrManager()">
                    <ngx-dropzone-label *ngIf="true">UPLOAD SOF</ngx-dropzone-label>
                    <ngx-dropzone-preview *ngFor="let f of filesSof" [removable]="true" (removed)="onRemoveSof(f)">
                      <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>
                  <div [hidden]="!isUploading">
                    <div class="spinner-2">
                      <mat-spinner align="center" style="height: 30px; width: 30px;"></mat-spinner>
                    </div>
                  </div>
                  <button style="margin-top: 5px; margin-bottom: 15px;" *ngIf="true"
                          [disabled]="filesSof == null || filesSof.length <= 0 || isUploading" mat-raised-button color="primary" type="button"
                          (click)="uploadSofGeneric()">Upload
                  </button>
                </mat-expansion-panel>
              </div>








          <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left; width: 120px;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
              <th style="text-align: left"><label>File</label></th>
              <th style="text-align: left"><label>Status</label></th>
            </tr>
            <ng-container  *ngFor="let f of idvUploadFiles">
            <tr [class.noborderbottom]="f.comment">
              <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{getSofTypeName(f.typName)}}</label></td>
              <td><label>{{f.docType}}</label></td>
              <td>
                <label *ngIf="currentUserIsAdminOrCompliance()">
                  <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                </label>
                <label *ngIf="!currentUserIsAdminOrCompliance()">
                  {{ f.originalFileName }}
                </label>
              </td>
              <td>
                <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                <label *ngIf="f.isSuccess == null">-</label>
              </td>
            </tr>
              <ng-container *ngIf="f.comment">
                <tr>
                  <td colspan="5" style="border-top: none; font-size: .8em; ">
                    <div>
                      📑 {{f.comment}}
                    </div>
                    <div style="font-weight: bold; font-size: .9em; padding-left: 5px;font-family: monospace">
                      {{f.decisionUserInitials}} ({{f.decisionUserEmail}})
                    </div>
                  </td>

                </tr>
              </ng-container>

            </ng-container>
          </table>
          <hr *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived"  />
          <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
            {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br /><br />
            <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsLink(customer)">resend Doc Link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount" (click)="resendDocsPaymentLink(customer)">resend payment link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsInvoice(customer)">send Invoice</button>
          </div>

        </mat-card-content>
      </mat-card>



      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
        <mat-card-header>
          <mat-card-title>
            <h5>🏡 Address Confirmation</h5>
          </mat-card-title>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <a style="font-size: .9em;" [routerLink]="'../../address-customers-overview/' + customer?.id">Approve / Decline</a>
          </div>

        </mat-card-header>
        <mat-card-content>

              <!-- ADDRESS CONFIRMATION UPLOAD -->


              <div *ngIf="currentUserIsAdminOrComplianceOrManager()" style="margin-bottom: 15px;">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title style="width: 100%">
                      <h5>Upload Address Confirmation <ng-container *ngIf="!lastAddressConfirmationLinkToken"> <span style="color: dodgerblue">(Direct upload, no active link)</span></ng-container></h5>
                    </mat-panel-title>
                    <mat-panel-description>

                    </mat-panel-description>
                  </mat-expansion-panel-header>


                  <ngx-dropzone (change)="onSelectAddressConfirmation($event)" [accept]="'image/*, application/pdf'" [multiple]="true"
                                [maxFileSize]="10485760" [disabled]="!currentUserIsAdminOrComplianceOrManager()">
                    <ngx-dropzone-label *ngIf="true">UPLOAD ADDRESS CONFIRMATION</ngx-dropzone-label>
                    <ngx-dropzone-preview *ngFor="let f of filesAddressConfirmation" [removable]="true" (removed)="onRemoveAddressConfirmation(f)">
                      <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>
                  <div [hidden]="!isUploading">
                    <div class="spinner-2">
                      <mat-spinner align="center" style="height: 30px; width: 30px;"></mat-spinner>
                    </div>
                  </div>
                  <button style="margin-top: 5px; margin-bottom: 15px;" *ngIf="true"
                          [disabled]="filesAddressConfirmation == null || filesAddressConfirmation.length <= 0 || isUploading" mat-raised-button color="primary" type="button"
                          (click)="uploadAddressConfirmation()">Upload
                  </button>
                </mat-expansion-panel>
              </div>

          <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left; width: 120px;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
              <th style="text-align: left"><label>File</label></th>
              <th style="text-align: left"><label>Status</label></th>
            </tr>
            <ng-container  *ngFor="let f of addressUploadFiles">
              <tr [class.noborderbottom]="f.comment">
                <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
                <td><label>{{getPoaTypeName(f.typName)}}</label></td>
                <td><label>{{f.docType}}</label></td>
                <td>
                  <label *ngIf="currentUserIsAdminOrCompliance()">
                    <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                  </label>
                  <label *ngIf="!currentUserIsAdminOrCompliance()">
                    {{ f.originalFileName }}
                  </label>
                </td>
                <td>
                  <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                  <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                  <label *ngIf="f.isSuccess == null">-</label>
                </td>
              </tr>
              <ng-container *ngIf="f.comment">
                <tr>
                  <td colspan="5" style="border-top: none; font-size: .8em; ">
                    <div>
                      📑 {{f.comment}}
                    </div>
                    <div style="font-weight: bold; font-size: .9em; padding-left: 5px;font-family: monospace">
                      {{f.decisionUserInitials}} ({{f.decisionUserEmail}})
                    </div>
                  </td>

                </tr>
              </ng-container>

            </ng-container>
          </table>
          <hr *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived"  />
          <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
            {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br /><br />
            <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsLink(customer)">resend Doc Link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount" (click)="resendDocsPaymentLink(customer)">resend payment link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsInvoice(customer)">send Invoice</button>
          </div>

        </mat-card-content>
      </mat-card>


      <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
        <mat-card-header>
          <mat-card-title>
            <h5>📑 All Documents</h5>
          </mat-card-title>
          <div fxFlex></div>


        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoadingAllDocuments">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left; width: 120px;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
              <th style="text-align: left"><label>File</label></th>
              <th style="text-align: left"><label>Status</label></th>
            </tr>
            <tr *ngFor="let f of allDocuments">
              <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{f.typName}}</label></td>
              <td><label>{{f.docType}}</label></td>
              <td>
                <label *ngIf="currentUserIsAdminOrCompliance()">
                  <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                </label>
                <label *ngIf="!currentUserIsAdminOrCompliance()">
                  {{ f.originalFileName }}
                </label>
              </td>
              <td>
                <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                <label *ngIf="f.isSuccess == null">-</label>
              </td>
            </tr>
          </table>
          <hr *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived"  />
          <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
            {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br /><br />
            <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsLink(customer)">resend Doc Link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount" (click)="resendDocsPaymentLink(customer)">resend payment link</button>
            <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsInvoice(customer)">send Invoice</button>
          </div>

        </mat-card-content>
      </mat-card>


      <!-- card have been here until 2023-08-01 -->

      <mat-card class="content-card" *ngIf="!currentUserIsIssuerExternal()">
        <mat-card-header>
          <mat-card-title>
            <h5>📄 Orders</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="list-item">
            <span fxFlex="25" *ngFor="let field of ordersFields">
                <label *ngIf="orders" class="secondary" >{{field.header}}</label>
            </span>
            <span>&nbsp;</span>
          </div>
          <div class="" fxLayout="row" *ngFor="let order of orders; let i = index">
            <mat-expansion-panel fxFlex="100" >
              <mat-expansion-panel-header class="">
                <span fxFlex="25" *ngFor="let field of ordersFields" >
                  <label class="{{ order.order.archived ? 'archived ': ''}}{{(order.order.status == 4 && field.header == 'Status' ) ? 'warning-row' : ''}}" *ngIf="field.type !== 'button'">{{field.cell(i)}}</label>


                </span>
              </mat-expansion-panel-header>



              <div class="list-item">
                  <span class="mr-2" *ngIf="!order || !order.order">Order not exist/or has been removed</span>


                  <div class="text-right">
                    <button mat-raised-button class="mr-1" color="blue" [disabled]="isResendWebidDisabled(order.order)" (click)="resendWebIdLink(order.order)">Resend Ident Link</button>




                    <button mat-raised-button class="ml-2 mr-4" color="warn"  *ngIf="currentUserIsAdmin()" [disabled]="cancelOrderDisabled(order.order)" (click)="cancelOrder(order.order.id)">Cancel order</button>

                    <button mat-raised-button class="ml-2 mr-4" color="warn"  *ngIf="currentUserIsPartner() || currentUserIsComplianceOrManagerOrAgent()" [disabled]="CancelOrderDisabled(order.order)" (click)="cancelOrder(order.order.id)">Cancel order</button>

                    <button *ngIf="order.order && !getOrderItemById(order.order.id).editVisible" class="" mat-raised-button color="primary" (click)="onShowOrderEdit(order.order.id, true)" [disabled]="!(currentUserIsAdminOrCompliance() && allowEditOrder(order.order))">Edit</button>
                  </div>


                  <form *ngIf="order.order && getOrderItemById(order.order.id).editVisible" (ngSubmit)="onOrderEditFormSubmit(order.order.id)" [formGroup]="getOrderItemById(order.order.id).editForm" class="">

                        <mat-form-field>
                          <input matInput placeholder="ExternalRef" formControlName="externalRef" readonly required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Card name" formControlName="cardName" maxlength="19" pattern="[a-zA-Z'-\s]*" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Sex" formControlName="sex" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Title" formControlName="title" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="First Name" formControlName="firstName" pattern="[a-zA-Z'-\s]*" maxlength="50" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Last Name" formControlName="lastName" pattern="[a-zA-Z'-\s]*" maxlength="50" required>
                        </mat-form-field>
                        <app-date-edit placeholder="Date of birth" formControlName="dob" required></app-date-edit>
                        <mat-form-field>
                          <input matInput placeholder="Email" formControlName="email" maxlength="60" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Mobile" formControlName="phone" minlength="9" maxlength="15" required>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-select placeholder="Product" formControlName="productId">
                            <mat-option *ngFor="let product of products" [value]="product.id">{{product.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-select placeholder="Country" formControlName="countryIsoCode">
                            <mat-option *ngFor="let country of countiries" [value]="country.isoCode">{{country.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Address" formControlName="address" maxlength="50" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="City" formControlName="city" maxlength="50" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Zip Code" formControlName="zipCode" maxlength="50" required>
                        </mat-form-field>
                    <mat-form-field>
                      <mat-select placeholder="Order language" formControlName="orderLanguage" required>
                        <mat-option [value]="0">german</mat-option>
                        <mat-option [value]="1">english</mat-option>
                      </mat-select>
                    </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Nationality" formControlName="nationality" required>
                        </mat-form-field>
                        <mat-form-field>
                          <input matInput placeholder="Ip Address" formControlName="ipAddress" readonly required>
                        </mat-form-field>
                        <app-date-edit placeholder="Order date" formControlName="orderDate" [readOnly]=true required></app-date-edit>

                     <div class="text-right mt-2">
                        <button mat-raised-button color="accent" type="button" (click)="onShowOrderEdit(order.order.id, false)"  class="mr-1">Cancel</button>
                        <button mat-raised-button color="primary" type="submit" [disabled]="!getOrderItemById(order.order.id).editForm.valid">Save</button>
                     </div>

                  </form>


                  <div *ngIf="order.order && !getOrderItemById(order.order.id).editVisible">

                    <div class="text-right mt-2 mb-2">

                    </div>

                    <!-- #region reorder details -->
                    <ng-container *ngIf="order.order && order.order.isReorderOrder">

                      <div style="background-color: lightskyblue; padding: 0 5px">
                        <h5>Re-Order</h5>
                      </div>

                    </ng-container>
                    <!-- #region reorder details -->

                    <ng-container *ngIf="order.order.loadAmount > 0">
                      <div style="background-color: dodgerblue; padding: 0 5px">
                        Card will be created with balance {{ order.order.loadAmount | number : '1.2-2' }}
                      </div>
                    </ng-container>


                    <table  class="list-table">

                    <tr>
                      <td class="secondary">ExternalRef</td>
                      <td><label>{{ order.order.externalRef }}</label></td>
                    </tr>
                    <tr>
                      <td class="secondary">Card Name</td>
                      <td><label>{{ order.order.cardName }}</label></td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <mat-expansion-panel class="" *ngIf="order.invoice">
                        <mat-expansion-panel-header>
                          <span class="{{ order.invoice.archived ? 'archived ': ''}}">
                            Invoice {{ order.invoice.code }}
                          </span>
                        </mat-expansion-panel-header>
                        <div style="background: #e3f3ff;" *ngIf="!getOrderItemById(order.id).invoiceEditVisible">
                          <div class="list-item" fxLayout="row" *ngFor="let field of invoiceFields;">
                            <div fxFlex="35" class="secondary">{{ field.header }}</div>
                            <div fxFlex="65" >{{ field.cell(order.invoice) }}</div>
                          </div>
                          <div class="text-right mt-2" style="padding-right: 5px; padding-bottom: 5px;">
                            <button mat-raised-button color="primary" [disabled]="!currentUserIsAdmin()" type="button" (click)="onShowOrderInvoiceEdit(order.order, true)">Edit</button>
                          </div>
                        </div>

                        <form *ngIf="order.invoice && getOrderItemById(order.id).invoiceEditVisible" [formGroup]="order.invoiceEditForm" (ngSubmit)="onOrderInvoiceEditSubmit(order.order)" class="content-card cardEdit">
                          <mat-card class="form-card">
                            <mat-card-content>
                              <mat-form-field >
                                <input matInput placeholder="Bill amount" formControlName="billAmount" readonly="true">
                              </mat-form-field>
                              <mat-form-field>
                                <input matInput placeholder="Paid amount" formControlName="paidAmount" required  type="number">
                              </mat-form-field>
                            </mat-card-content>
                            <mat-card-actions align="end">
                              <button mat-raised-button color="accent" type="button" (click)="onShowOrderInvoiceEdit(order.order, false)">Cancel</button>
                              <button mat-raised-button color="primary" type="submit" [disabled]="!order.invoiceEditForm.valid || order.invoiceEditForm.pristine">Save</button>
                            </mat-card-actions>
                          </mat-card>
                        </form>

                        <app-object-comments-view class="mt-2" caption="{{ order.invoice.code }} comments" *ngIf="order.invoice" [comments]="order.invoiceComments" [objectId]="order.invoice?.id" [target]="commentsInvoiceTarget"></app-object-comments-view>



                      </mat-expansion-panel>
                      </td>
                    </tr>
                    <tr>
                      <td class="secondary">Partner Customer ID</td>
                      <td>
                        <label>
                          {{ order.order.partnerCustomerId }}
                        </label>
                      </td>
                    </tr>

                    <tr *ngFor="let field of ordersFields2">
                      <td class="secondary">{{ field.header }}</td>
                      <td *ngIf="order.order"><label>{{ field.cell(order.order) }}</label></td>

                    </tr>

                      <tr *ngIf="this.isWebIdDownloadVisible">
                        <td class="secondary">Ident file</td>
                        <td>
                          <div *ngIf="this.isWebIdDownloadVisible">
                            <i *ngIf="order.order.webIdTransaction?.responseFileId" class="material-icons cursor-pointer" (click)="downloadAttachment(order.order.webIdTransaction.responseFileId)" >cloud_download</i>
                            <label *ngIf="!order.order.webIdTransaction?.responseFileId">-</label>
                          </div>
                        </td>
                      </tr>

                      <tr *ngIf="order.order.webIdTransaction">
                        <td class="secondary">Ident type</td>
                        <td>
                          <label *ngIf="order.order.webIdTransaction.providerCode == 0">
                            WebID
                          </label>
                          <label *ngIf="order.order.webIdTransaction.providerCode == 1">
                            Onfido
                          </label>
                          <label *ngIf="order.order.webIdTransaction.providerCode == 2">
                            Veriff
                          </label>
                        </td>
                      </tr>



                    <ng-container *ngIf="order.order && order.order.cancellationReason != null">
                      <tr *ngFor="let field of cancellationFields">
                        <td class="secondary"><label>{{ field.header }}</label></td>
                        <td *ngIf="order.order"><label>{{ field.cell(order.order) }}</label></td>
                      </tr>
                    </ng-container>

                      <ng-container *ngIf="order.order && order.order.userCancellationReasonName">
                        <tr *ngFor="let field of cancellationExtraFields">
                          <td class="secondary"><label>{{ field.header }}</label></td>
                          <td *ngIf="order.order"><label>{{ field.cell(order.order) }}</label></td>
                        </tr>
                      </ng-container>
                  </table>

                  </div>
              </div>





            </mat-expansion-panel>
          </div>
        </mat-card-content>

      </mat-card>


      <mat-card class="content-card" *ngIf="!currentUserIsPartner()">
        <mat-card-header style="display: inherit">
          <mat-card-title>
            <div fxFlex="50">
              <h5>💶 Load history</h5>
            </div>
            <div fxFlex="50" style="text-align: right;">
              <ng-container *ngIf="loadHistorySums && loadHistorySums.length > 0">
                <div *ngFor="let acc of loadHistorySums">
                  <b>Sum Loads 1Y: {{ acc.amount.formatMoneyCcy(acc.currencyCode) }}</b>
                </div>
              </ng-container>

              <ng-container *ngIf="loadHistoryPendingSums && loadHistoryPendingSums.length > 0">
                <div *ngFor="let acc of loadHistoryPendingSums" style="color: grey;">
                  <ng-container *ngIf="acc.amount > 0.1">Sum Pending: {{ acc.amount.formatMoneyCcy(acc.currencyCode) }}</ng-container>
                </div>
              </ng-container>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>


          <ng-container *ngIf="isLoadingBankTransferLoads">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <div class="loads-scroll">


            <div style="margin: 5px;">
              <div style="width: 100%; height: 25px; " *ngIf="this.customerRisk && this.customerRisk.riskSumLoadTotal > 0">
                <div [style.width]="(this.customerRisk.riskSumBankTransferLoad * 100 / this.customerRisk.riskSumLoadTotal) + '%'" style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: dodgerblue; height: 20px; float: left;">BTL</div>
                <div [style.width]="(this.customerRisk.riskSumLoadSofort * 100 / this.customerRisk.riskSumLoadTotal) + '%'" style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: forestgreen; height: 20px; float: left;">SOF</div>
                <div [style.width]="(this.customerRisk.riskSumLoadSepa * 100 / this.customerRisk.riskSumLoadTotal) + '%'" style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: mediumpurple; height: 20px; float: left;">SEP</div>
                <div [style.width]="(this.customerRisk.riskSumCardToCardInbound * 100 / this.customerRisk.riskSumLoadTotal) + '%'" style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: orange; height: 20px; float: left;">C2C</div>
              </div>
              <ng-container *ngIf="isLoadingRisk">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </ng-container>
            </div>

            <div class="list-item" fxLayout="row" fxLayoutGap="10px">
              <label fxFlex="20" class="secondary">Date</label>
              <label fxFlex="16" class="secondary">Token</label>
              <label fxFlex="16" class="secondary">Amount</label>
              <label fxFlex="15" class="secondary">Status</label>
              <label fxFlex="35" class="secondary">Risk</label>
              <label fxFlex="15" class="secondary"></label>


            </div>
            <div>
              <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let load of loadHistory" >
                <label class="" fxFlex="20" >{{ load.createDate | date: "dd.MM.yyyy" }}</label>
                <label class="" fxFlex="16" style="vertical-align: top">
                  <div style="display: inline-block"><mat-icon [ngStyle]="{fontSize: '1.2em', color: (load.loadType == 1 ? 'grey':'blue')}">{{load.loadType == 1 ? "account_balance" : "assignment_ind"}}</mat-icon></div>
                  <div style="display: inline-block; vertical-align: top">{{load.card.token}}</div>
                </label>
                <label class="" fxFlex="16" >
                  {{load.amountToLoad.formatMoneyEuro()}}
                </label>
                <label class="" fxFlex="15" >

                  <!-- load status icons -->
                  <div *ngIf="load.isConfirmed && load.amountAlreadyLoaded >= load.amountToLoad">
                    <mat-icon matTooltip="Confirmed" style="color: green">done_all</mat-icon>
                  </div>
                  <div *ngIf="load.isConfirmed && load.amountAlreadyLoaded < load.amountToLoad">
                    <mat-icon matTooltip="Confirmed partial" style="color: deeppink;">done_all</mat-icon>
                  </div>
                  <ng-container *ngIf="!load.isConfirmed">
                    <div matTooltip="Approved automatically" *ngIf="load.isApprovedAutomatically && !load.isApprovedManually && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: dodgerblue">done</mat-icon>
                    </div>
                    <div matTooltip="Approved manually" *ngIf="load.isApprovedManually && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: forestgreen">done</mat-icon>
                    </div>
                    <div  matTooltip="Declined" *ngIf="load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: red;">clear</mat-icon>
                    </div>
                    <div  matTooltip="Needs approval" *ngIf="load.needsManualApproval && !load.isApprovedManually && !load.isApprovedAutomatically && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: orange">search</mat-icon>
                    </div>
                    <div  matTooltip="Needs 2 approvals" *ngIf="load.needsManualApproval && load.needsPreApproval && !load.isApprovedManually && !load.isApprovedAutomatically && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: purple">search</mat-icon>
                    </div>
                  </ng-container>

                  <div style="color: red;" *ngIf="load.isMarkedForRefund && !load.isRefunded">to refund</div>
                  <div style="color:red;" *ngIf="load.isMarkedForRefund && load.isRefunded">refunded</div>

                </label>
                <label class="" fxFlex="35" >
                  <div *ngIf="load.riskLevel === 0" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Low</div>
                  <div *ngIf="load.riskLevel === 1" style="background-color: orange; color: black; border-radius: 5px; font-weight: bold; padding: 4px;">Medium</div>
                  <div *ngIf="load.riskLevel === 2" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">High</div>
                  <div *ngIf="load.riskLevel === 99" style="background-color: black; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Unknown</div>

                  <div>
                    <small>
                      <ng-container *ngIf="load.trustPayTransaction && load.trustPayTransaction.counterAccount">
                        <ng-container *ngIf="load.trustPayTransaction.counterAccountName">
                          {{ load.trustPayTransaction.counterAccountName.substr(0,40) }}<br/>
                        </ng-container>
                        {{ load.trustPayTransaction.counterAccountMasked }}
                      </ng-container>
                    </small>
                  </div>

                </label>
                <label fxFlex="15">
                  <a [routerLink]="'../../loads/btl/' + load.id">Detail</a>
                </label>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="content-card" *ngIf="!currentUserIsPartner()">
        <mat-card-content>
          <mat-card-header style="display: inherit">
            <mat-card-title>
              <div fxFlex="50">
                <h5>📥 Inbound Card-To-Card</h5>
              </div>
              <div fxFlex="50" style="text-align: right;">
                <ng-container *ngIf="inboundC2CHistorySums && inboundC2CHistorySums.length > 0">
                  <div *ngFor="let acc of inboundC2CHistorySums">
                    <b>SUM C2C IN 1Y: {{ acc.amount.formatMoneyCcy(acc.currencyCode) }}</b>
                  </div>

                </ng-container>
              </div>
            </mat-card-title>
          </mat-card-header>


          <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
            <label fxFlex="20" class="secondary">Date</label>
            <label fxFlex="16" class="secondary">To</label>
            <label fxFlex="16" class="secondary">From</label>
            <label fxFlex="16" class="secondary">Amount</label>
            <label fxFlex="15" class="secondary">Status</label>
            <label fxFlex="15" class="secondary"></label>


          </div>
          <ng-container *ngIf="isLoadingInboundCardToCardTransfers">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>
          <div *ngIf="inboundCardToCardTransfers">
            <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let c2c of inboundCardToCardTransfers" >
              <label class="" fxFlex="20" >{{ c2c.transferDate | date: "dd.MM.yyyy" }}</label>
              <label class="" fxFlex="16" style="vertical-align: top">
                {{c2c.destinationCard.token}}
              </label>
              <label class="" fxFlex="16" style="vertical-align: top">
                <ng-container *ngIf="c2c.sourceCard">
                  {{c2c.sourceCard.token}}
                </ng-container>
                <ng-container *ngIf="!c2c.sourceCard">
                  <i>unknown</i>
                </ng-container>
              </label>
              <label class="" fxFlex="16" >
                {{c2c.amount.formatMoneyEuro()}}
              </label>
              <label class="" fxFlex="15" >
                📥
              </label>
              <label fxFlex="15">

              </label>
            </div>
          </div>


        </mat-card-content>
      </mat-card>





    </div>
    <div fxFlex="50">

      <mat-card class="content-card">
        <mat-card-content>

          <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
            <label fxFlex="20" class="secondary">Device</label>
            <label fxFlex="15" class="secondary">Brand</label>
            <label fxFlex="5" class="secondary">Platform</label>
            <label fxFlex="15" class="secondary">App Version</label>
            <label fxFlex="10" class="secondary">OS</label>
            <label fxFlex="10" class="secondary">Notif.</label>
          </div>
          <div id="scroll1">
            <ng-container  *ngFor="let device of devicesLoggedIn">
              <div class="list-item" fxLayout="row" fxLayoutGap="10px">
                <label class="" fxFlex="20" >{{ device.deviceModelFriendly ?? device.deviceModel }}</label>
                <label class="" fxFlex="15" >{{ device.brand }}</label>
                <label class="" fxFlex="15" >{{ device.platform }}, {{ device.osVersion }}</label>
                <label class="" fxFlex="15" >{{ device.appVersion }}</label>
                <label class="" fxFlex="15" >
                  <ng-container *ngIf="device.notificationPermission">🔔 Yes</ng-container>
                  <ng-container *ngIf="!device.notificationPermission">🔇 No</ng-container>
                </label>
                <label class="" fxFlex="10" ><span (click)="logoutDevice(device.deviceToken)" style="cursor: pointer"><mat-icon style="color: red;">clear</mat-icon></span></label>
              </div>


            </ng-container>

            <ng-container *ngIf="devicesLoggedIn.length == 0">
              <div style="text-align: center; padding: 10px; ">
              <i>- no active devices -</i>
              </div>
            </ng-container>

          </div>




        </mat-card-content>
      </mat-card>

      <mat-card class="content-card">
        <mat-card-content>

         <div style="width: 100%; padding: 5px;">



      <mat-tab-group *appHasRoles="['admin', 'manager', 'agent', 'compliance']">
        <mat-tab label="📱 Send SMS">


              <!-- (ngSubmit)="onSendSms(smsForm)" -->
              <form *ngIf="smsForm" [formGroup]="smsForm" class="content-card" >
                <mat-form-field >
                  <input matInput placeholder="Mobile" formControlName="mobile" [disabled]="true" [readonly]="true" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15">
                </mat-form-field>
                <mat-form-field>
                  <textarea rows="6" matInput placeholder="Message" formControlName="message" #textareamessage required></textarea>
                </mat-form-field>
                <span *ngIf="smsForm?.controls['message']?.value?.length > 160" style="color: red;">
              ~ {{ smsForm?.controls['message']?.value?.length }}
            </span>
                <span *ngIf="smsForm?.controls['message']?.value?.length <= 160" style="color: green;">
              ~ {{ smsForm?.controls['message']?.value?.length }}
            </span>
                <span>
              &nbsp;/&nbsp; 160 &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
              </form>


              <button mat-raised-button color="primary" type="submit" *ngIf="smsForm?.controls['mobile']?.value != null" [disabled]="(smsForm?.controls['message']?.value?.trim().length < 1) || isSmsSending" (click)="onSendSms(smsForm)">Send SMS</button>

        </mat-tab>
        <mat-tab label="📱 Push Notification">
            <form *ngIf="pushForm" [formGroup]="pushForm" class="content-card" >
              <div>
              <mat-checkbox formControlName="isSilent">Silent message</mat-checkbox>
              </div>
              <ng-container *ngIf="pushForm.get('isSilent').value == false">
                <div>
                  <small>Notification</small>
                </div>

                <mat-form-field>
                  <input matInput placeholder="Notification Title" formControlName="notificationTitle">
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Notification Text" formControlName="notificationText">
                </mat-form-field>

                <mat-form-field>
                  <mat-select placeholder="Severity" formControlName="severity" required>
                    <mat-option value="">(None)</mat-option>
                    <mat-option value="success">Success</mat-option>
                    <mat-option value="info">Info</mat-option>
                    <mat-option value="warn">Warning</mat-option>
                    <mat-option value="error">Error</mat-option>
                  </mat-select>
                </mat-form-field>

                <div>
                  <small>Body (when user taps on notification)</small>
                </div>
                <mat-form-field>
                  <input matInput placeholder="Body Title" formControlName="bodyTitle">
                </mat-form-field>
                <mat-form-field>
                  <textarea rows="6" matInput placeholder="Body Text" formControlName="bodyText"></textarea>
                </mat-form-field>
              </ng-container>

              <mat-form-field>
                <mat-select placeholder="Action" formControlName="action">
                  <mat-option value="">(None)</mat-option>
                  <mat-option value="add_card">Add card</mat-option>
                  <mat-option value="top_up">Top-Up</mat-option>
                  <mat-option value="confirm_address">Confirm address</mat-option>
                  <mat-option value="change_address">Change address</mat-option>
                  <mat-option value="ident">Ident</mat-option>
                  <mat-option value="gift_cards">Gift cards</mat-option>
                  <mat-option value="refer_friends">Refer friends</mat-option>
                  <mat-option value="partner_offers">Partner offers</mat-option>
                  <mat-option value="dynaview">DynaView</mat-option>
                  <mat-option value="transactions">Transactions</mat-option>
                  <mat-option value="upgrades">Upgrades</mat-option>
                  <mat-option value="link">Link</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Action parameter" formControlName="actionParameter">
              </mat-form-field>


              <mat-form-field>
                <textarea rows="6" matInput placeholder="Data" formControlName="dataString"></textarea>
              </mat-form-field>

            </form>


          <button mat-raised-button color="primary" type="submit" [disabled]="isPushSending" (click)="onSendPush(pushForm)">Send Push</button>


        </mat-tab>

        <mat-tab label="📱 Push Data">
          <form *ngIf="pushDataForm" [formGroup]="pushDataForm" class="content-card" style="padding: 5px;">
            <div>
              <mat-checkbox formControlName="reloadCards">Reload Cards</mat-checkbox>
            </div>
            <div>
              <mat-checkbox formControlName="reloadAccount">Reload Account</mat-checkbox>
            </div>
            <div>
              <mat-checkbox formControlName="reloadPendingLoads">Reload Pending Loads</mat-checkbox>
            </div>
            <div>
              <mat-checkbox formControlName="reloadNextSteps">Reload Next Steps</mat-checkbox>
            </div>

          </form>


          <button mat-raised-button color="primary" type="submit" [disabled]="isPushDataSending" (click)="onSendPushData(pushDataForm)">Send Push Data</button>


        </mat-tab>

      </mat-tab-group>

         </div>

        </mat-card-content>

      </mat-card>
      <app-object-comments-view *ngIf="customer" [comments]="comments" [objectId]="customer?.id" [target]="commentsTarget"></app-object-comments-view>

      <ng-container *ngIf="isLoadingSmsEmailLogs">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-email-log-view-container [logs]="smsEmailLogs" class="mt-2"></app-customer-email-log-view-container>

      <ng-container *ngIf="isLoadingFcmSents">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-fcm-logs [fcmSents]="fcmSents" class="mt-2"></app-customer-fcm-logs>


      <app-event-log-view [isLoading]="isLoadingLogs" [logs]="logs" *ngIf="showLogs()"></app-event-log-view>

      <app-customer-micropayment-sessions-view [isLoading]="isLoadingMicroPaymentSessions" [sessions]="microPaymentSessions" class="mt-2"></app-customer-micropayment-sessions-view>

      <app-customer-whitelisted-bankaccounts-view [isLoading]="isLoadingWhiteListedBankAccounts" [whiteListedBankAccounts]="whiteListedBankAccounts" class="mt-2"></app-customer-whitelisted-bankaccounts-view>

      <ng-container *ngIf="isLoadingInvoices || isLoadingAnnualFeeDeductions">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-invoice-log-view [invs]="invoices" [annualFeeDeductions]="annualFeeDeductions" class="mt-2"></app-customer-invoice-log-view>

      <ng-container *ngIf="isLoadingAnnualFees">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-annual-fees-view [annualFees]="annualFees" class="mt-2"></app-customer-annual-fees-view>

      <!--<ng-container *ngIf="isLoadingAnnualFeeDeductions">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-annual-fee-deduction-log-view [annualFeeDeductions]="annualFeeDeductions" class="mt-2"></app-customer-annual-fee-deduction-log-view>
-->
      <div style="" class="content-card full-card">
        <mat-card class="form-card">
          <mat-card-header>
            <mat-card-title>
              <h5>🔮 Card Processor Enquiry</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-expansion-panel disabled=true>
              <mat-expansion-panel-header>
                <mat-panel-title style="width: 35px;">

                </mat-panel-title>
                <mat-panel-title>
                  Card
                </mat-panel-title>
                <mat-panel-title>
                  Token
                </mat-panel-title>
                <mat-panel-title>
                  Last 4, Expiry
                </mat-panel-title>

                <mat-panel-title>
                  Status
                </mat-panel-title>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let cardContainer of cardContainers">
              <mat-expansion-panel-header>
                <mat-panel-title style="width: 35px;">
                  <img *ngIf="productLogoUrl[cardContainer.card.productId]" [src]="productLogoUrl[cardContainer.card.productId]" style="width: 30px; height: 19px;" alt="Product Logo" />
                </mat-panel-title>
                <mat-panel-title>
                  {{cardContainer.card.product.internalName}}
                </mat-panel-title>
                <mat-panel-title>
                  <span *ngIf="cardContainer.card.usageStatus == cardUsageStatus.dormant" [matTooltip]="'Dormant card'">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">💤</div>
                  </span>
                  <span *ngIf="cardContainer.card.primaryCardId">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">⛓</div>
                  </span>
                  {{cardContainer.card.token}}
                </mat-panel-title>
                <mat-panel-title>
                  <span *ngIf="cardContainer.card.maskedPAN">
                    *{{cardContainer.card.maskedPAN.substring(12)}}
                  </span>, {{cardContainer.card.expireDate | date: 'MM/yy'}}
                </mat-panel-title>

                <mat-panel-title class="{{cardContainer.card.status == 6 ? 'warning-row' : ''}}">
                  <span *ngIf="cardContainer.card.status == 6">⛔️ </span>
                  {{cardContainer.card.statusName}}<div style="display: inline-block; margin-left: 4px; padding: 3px; background-color: dodgerblue; color: black; font-size: .8em;" *ngIf="cardContainer.card.reorderReason">R</div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <button mat-raised-button color="primary" (click)="getStatement2(cardContainer)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get statement</button>
              <button mat-raised-button color="primary" (click)="getCardholderDetails(cardContainer)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get cardholder details</button>
              <button mat-raised-button color="primary" (click)="getCardInfos(cardContainer)" [disabled]="!isGpsButtonEnabled()">Get card infos</button>

              <small style="color: red; margin-left: 20px;">Enquiries will be logged!</small>



              <div [hidden]="!isStatementLoading" style="margin-top: 10px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>



              <!-- new dto with single transactions -->



              <div *ngIf="cardContainer.statement2 && cardContainer.statement2DataSource" style="margin-top: 10px;" class="statement">
                <h4>Statement - last year</h4>

                <table mat-table matSort [dataSource]="cardContainer.statement2DataSource" multiTemplateDataRows class="mat-elevation-z8" style="width: 100%;">

                  <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                  <ng-container matColumnDef="direction">
                    <th mat-header-cell *matHeaderCellDef style="width: 25px;"></th>
                    <td mat-cell *matCellDef="let element">
                      <ng-container *ngIf="element.currentStatus === eTransactionStatus.Authorized">⌛️</ng-container>
                      <ng-container *ngIf="element.currentStatus === eTransactionStatus.AuthorizationReversed">↩️️</ng-container>
                      <ng-container *ngIf="element.currentStatus === eTransactionStatus.Reversed">↩️↩️️</ng-container>
                      <ng-container *ngIf="txnIsLoad(element)">💰</ng-container>
                      <ng-container *ngIf="txnIsUnload(element)">💸</ng-container>
                      <ng-container *ngIf="!txnIsLoad(element) && !txnIsUnload(element) && element.currentStatus === eTransactionStatus.Settled">✅</ng-container>
                      <ng-container *ngIf="txnIsBalanceAdj(element) && element.billAmt > 0">🔼</ng-container>
                      <ng-container *ngIf="txnIsBalanceAdj(element) && element.billAmt < 0">🔽</ng-container>
                      <ng-container *ngIf="element.currentStatus === eTransactionStatus.Declined">⛔️</ng-container>

                    </td>
                  </ng-container>

                  <ng-container matColumnDef="transactionDate">
                    <th mat-header-cell *matHeaderCellDef style="width: 100px;">Date</th>
                    <td mat-cell *matCellDef="let element"> {{ element.firstTxnDate | date:'dd.MM.yyyy'}} </td>
                  </ng-container>

                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%;"> Description </th>
                    <td mat-cell *matCellDef="let element" style="width: 30%;">
                      <div *ngIf="cardContainer.gpsPosDataList.has(element.gpsPosData)" style="font-size: .9em; font-family: monospace; margin-bottom: 2px;" [class]="'statement-posdata-' + element.currentStatus" data-pos-data="{{ element.gpsPosData }}">

                        <span class="posDataBadge posDataGood" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Passed">3DS ok</span>
                        <span class="posDataBadge posDataBad" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Failed">3DS fail</span>
                        <!--<span class="posDataBadge" *ngIf="(element.gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.NotPerformed">No 3DS</span>-->

                        <span [matTooltip]="'Card present'" class="posDataBadge posDataGood" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardPresent ?? CardPresent.Unknown) == CardPresent.Present">💳✅</span>
                        <span [matTooltip]="'Card not present'" class="posDataBadge posDataWarn" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardPresent ?? CardPresent.Unknown) == CardPresent.NotPresent">💳❌</span>
                        <span [matTooltip]="'Cardholder present'" class="posDataBadge posDataGood" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.Present">🙋✅</span>
                        <span [matTooltip]="'Cardholder not present'" class="posDataBadge posDataWarn" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.NotPresentUnspecified || (cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">🙋❌</span>

                        <span class="posDataBadge posDataInfo" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.RecurringTransaction">Recurring Txn</span>
                        <span class="posDataBadge posDataBad" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.TelephoneOrder">Tel. order</span>
                        <span class="posDataBadge posDataBad" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.MailOrder">Mail order</span>


                        <span class="posDataBadge posDataInfo" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.ECommerce || (cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">ECommerce</span>

                        <span class="posDataBadge posDataInfo" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.EMVContactless">EMV Contactless</span>
                        <span class="posDataBadge posDataGood" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.ChipDip">ChipDip</span>
                        <span class="posDataBadge posDataWarn" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.AccountDataOnFile">Acct.Data on File</span>
                        <span class="posDataBadge posDataBad" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.MagneticStripeRead">Mag. Stripe Read</span>
                        <span class="posDataBadge posDataBad" *ngIf="(cardContainer.gpsPosDataList.get(element.gpsPosData)?.cardDataInputMethod ?? false) == CardDataInputMethod.ContactlessMagStripe">Contactless Mag. Stripe</span>


                        <span class="posDataBadge posDataGood" *ngIf="isPinAuth(element.gpsPosData)">🔐 PIN</span>
                        <span class="posDataBadge posDataGood" *ngIf="isSecure3DsAuth(element.gpsPosData)">🔐 3DS</span>
                        <span class="posDataBadge posDataGood" *ngIf="isBiometricsAuth(element.gpsPosData)">🔐 Biometrics</span>

                      </div>

                      <div class="txn-description">{{element.description}}</div>
                      <div *ngIf="txnNote(element)" style="font-size: .8em; font-family: monospace;" [class]="'statement-note-' + element.currentStatus">
                        📝 {{txnNote(element)}}
                      </div>



                    </td>
                  </ng-container>

                  <ng-container matColumnDef="amountCurrency">
                    <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Amt. </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;">
                      <div [class]="'amount-' + element.currentStatus">
                        {{element.txnAmt.toFixed(2)}} {{element.currency}}
                      </div>
                      <div *ngIf="element.billAmt && element.billAmt != element.txnAmt">
                        <span style="font-size: .9em;"><i>{{element.billAmt.toFixed(2)}}</i></span>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fees">
                    <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Fee </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right;">
                      <div *ngIf="element.feeRate">
                        <span style="font-size: 12px;">Rate: </span>{{element.feeRate.toFixed(2)}}
                      </div>
                      <div *ngIf="element.feeFixed">
                        <span style="font-size: 12px;">Fixed: </span>{{element.feeFixed.toFixed(2)}}
                      </div>
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="statusDescription">
                    <th mat-header-cell *matHeaderCellDef style="width: 80px;  text-align: center;"> Status </th>
                    <td mat-cell *matCellDef="let element" style=" text-align: right;">
                      <div [class]="'status-' + element.currentStatus">
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Authorized">Auth</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Declined">Declined</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.AuthorizationReversed">Auth. Rev.</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Reversed">Reversed</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Settled">Settled</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Chargeback">Chargeback</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.ChargebackReversed">Chargeback Rev.</ng-container>
                        <ng-container *ngIf="element.currentStatus == eTransactionStatus.Other">Other</ng-container>
                      </div>
                      <div *ngIf="element.avlBal" style="font-size: 12px;">
                        Avl: {{element.avlBal.toFixed(2)}}
                      </div>
                      <div *ngIf="element.blkAmt" style="font-size: 12px;">
                        Blk: {{(element.blkAmt * -1).toFixed(2)}}
                      </div>

                      <div *ngIf="element.transactions != null && element.transactions.length > 1">
                        <span (click)="expandedStatementElement = expandedStatementElement == element ? null : element">
                          <ng-container *ngIf="expandedStatementElement == element"><mat-icon style="color: black;">arrow_drop_up</mat-icon></ng-container>
                          <ng-container *ngIf="expandedStatementElement != element"><mat-icon style="color: dimgrey;">arrow_drop_down</mat-icon></ng-container>
                        </span>
                      </div>

                    </td>
                  </ng-container>

                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedStatementColumns.length">
                      <div class="txn-detail"
                           [@detailExpand]="element == expandedStatementElement ? 'expanded' : 'collapsed'">

                        <table style="width: 100%" class="txnDetailTable">
                          <thead>
                          <td>Date</td>
                          <td style="text-align: right;">Amount</td>
                          <td>Type</td>
                          <td style="text-align: right;">Avl.</td>
                          <td style="text-align: right;">Blk.</td>
                          </thead>
                          <tbody>
                          <tr *ngFor="let txn of element.transactions">
                            <td>{{ txn.txnDate  | date:'dd.MM.yyyy HH:mm' }}</td>

                            <td style="text-align: right;">
                              {{ txn.txnAmt.toFixed(2) }}
                            </td>

                            <td>
                              <ng-container *ngIf="txn.txnType === 'A' && txn.txnStatCode === 'I'">Declined</ng-container>
                              <ng-container *ngIf="txn.txnType === 'A' && txn.txnStatCode === 'A'">Auth</ng-container>
                              <ng-container *ngIf="txn.txnType === 'P' && txn.txnStatCode === 'S'">Settlement</ng-container>
                              <ng-container *ngIf="txn.txnType === 'D' && txn.txnStatCode === 'A'">Auth. Reversal</ng-container>

                              <ng-container *ngIf="txn.txnType === 'L' && txn.txnStatCode === 'S'">Load</ng-container>
                              <ng-container *ngIf="txn.txnType === 'U' && txn.txnStatCode === 'S'">Unload</ng-container>
                              <ng-container *ngIf="txn.txnType === 'B' && txn.txnStatCode === 'S'">Bal.Adj.</ng-container>
                            </td>
                            <td style="text-align: right;">{{ txn.avlBal.toFixed(2) }}</td>
                            <td style="text-align: right;">{{ txn.blkAmt.toFixed(2) }}</td>

                          </tr>
                          </tbody>
                        </table>


                      </div>
                    </td>
                  </ng-container>


                  <tr mat-header-row *matHeaderRowDef="displayedStatementColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedStatementColumns;" [class.example-expanded-row]="expandedStatementElement === row" (click)="expandedStatementElement = expandedStatementElement === row ? null : row" class="txn-row"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="txn-detail-row"></tr>
                </table>
              </div>

              <!-- / new dto with single transactions -->




              <div [hidden]="!isCardholderDetailsLoading" style="margin-top: 10px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
              <div *ngIf="cardContainer.cardholderDetails">
                <h4>Cardholder details</h4>
                <div mat-dialog-content>
                  <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardholderDetails ">
                    <label fxFlex="35" class="secondary">{{ field.header }}</label>
                    <label fxFlex="65" *ngIf="cardContainer.cardholderDetails">{{ field.cell(cardContainer.cardholderDetails) }}</label>
                  </div>
                </div>
              </div>

              <div [hidden]="!isCardInfoLoading" style="margin-top: 10px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
              <div *ngIf="cardContainer.cardInfo">
                <h4>Card infos</h4>
                <div mat-dialog-content>
                  <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardInfo ">
                    <label fxFlex="35" class="secondary">{{ field.header }}</label>
                    <label fxFlex="65" *ngIf="cardContainer.cardInfo">{{ field.cell(cardContainer.cardInfo) }}</label>
                  </div>
                </div>
              </div>

            </mat-expansion-panel>
          </mat-card-content>
        </mat-card>
      </div>

      <app-customer-cashback-view [cardContainers]="cardContainers" [cashbacks]="cashbacks"></app-customer-cashback-view>

    </div>
  </div>
